import React from 'react'
import {
  ResponsiveContainer,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  ComposedChart,
} from 'recharts'

const DaysOnMarket = ({ data }) => {
  // Convert the data object into an array of objects for Recharts
  const chartData = Object.entries(data.mth).map(([month, values]) => ({
    month,
    avg: values.avg,
    count: values.count,
  }))

  return (
    <ResponsiveContainer width="100%" height={480}>
      <ComposedChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
      >
        <defs>
          <linearGradient id="colorProps" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8884d8" stopOpacity={1} />
            <stop offset="100%" stopColor="#4a49a5" stopOpacity={1} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          angle={-45}
          textAnchor="end"
        />
        <YAxis
          yAxisId="left"
          label={{
            value: 'Avg Days On Market',
            angle: -90,
            position: 'insideLeft', // Keeps it inside but away from the chart
            dx: -5, // Moves label further left
            dy: 0, // Adjust vertical positioning if needed
            style: { textAnchor: 'middle' }, // Centers the text
          }}
        />
        <YAxis
          yAxisId="right"
          orientation="right"
          label={{
            value: 'Total Properties For Sale',
            angle: -90,
            position: 'insideRight',
            dx: 15, // Moves label further right
            dy: 0,
            style: { textAnchor: 'middle' },
          }}
        />

        <Tooltip />
        <Legend wrapperStyle={{ paddingTop: 40 }} />
        <Bar
          yAxisId="right"
          dataKey="count"
          fill="url(#colorProps)"
          name="Total"
        />
        <Line
          yAxisId="left"
          type="monotone"
          dataKey="avg"
          stroke="#82ca9d"
          strokeWidth={3}
          dot={{ r: 5 }}
          name="Average"
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}

export default DaysOnMarket
